"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    height: "24",
    viewBox: "0 0 46.9 24",
    width: "46.9",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "m46.18 18.25h-1.24v-17.39a.86.86 0 0 0 -.86-.86h-28.53a.87.87 0 0 0 -.75.46l-5 9.91h-6.35a3.31 3.31 0 0 0 -3.45 3.28v5.29a.86.86 0 0 0 .86.86h3.05v.29a3.92 3.92 0 0 0 7.83 0c0-.1 0-.19 0-.29h12.9a2.85 2.85 0 0 0 0 .29 3.91 3.91 0 1 0 7.82 0c0-.09 0-.17 0-.26h13.54a.82.82 0 0 0 .9-.83.68.68 0 0 0 -.72-.75zm-36 1.84a2.36 2.36 0 1 1 -2.38-2.36 2.35 2.35 0 0 1 2.35 2.36zm20.66 0a2.35 2.35 0 1 1 -2.35-2.36 2.35 2.35 0 0 1 2.32 2.36zm-2.35-3.91a3.9 3.9 0 0 0 -3.49 2.05h-13.79a3.87 3.87 0 0 0 -6.83 0h-2.8v-4.58a1.72 1.72 0 0 1 1.72-1.72h6.87a.87.87 0 0 0 .77-.47l5.06-9.9h27.37v16.69h-11.32-.15a3.88 3.88 0 0 0 -3.44-2.07z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m20.3 4.85h-2.3a.81.81 0 0 0 -.7.43l-2.4 4.72a.78.78 0 0 0 .36 1 .69.69 0 0 0 .35.08.79.79 0 0 0 .7-.43l2.13-4.26h1.86a.79.79 0 0 0 0-1.57z"
  })));
};

exports["default"] = _default;